import Vue from 'vue';
export default Vue.extend({
    name: 'yubikeyConnectionPopupChunk',
    props: {
        slotData: {
            type: Object,
            required: false,
            default: () => ({
                additionalPopupContent: ''
            })
        }
    },
    data: () => ({
        letRetry: false
    }),
    methods: {
        startTimer() {
            const vm = this;
            vm.letRetry = false;
            setTimeout(() => {
                vm.letRetry = true;
            }, 30000);
        }
    },
    mounted() {
        const vm = this;
        vm.startTimer();
    }
});
